<template>
  <div class="vcl-bulk-action" :style="bulkStyles">
    <div v-if="visible && !disabled" class="vcl-bulk-action__menu">
      <div class="vcl-bulk-action__count">
        <span>{{ selected.length || 0 }} Item{{ selected && selected.length > 1 ? 's' : '' }} Selected</span>
      </div>
      <ul class="vcl-bulk-action__items">
        <template v-for="(item, index) in _actions">
          <li v-if="!item.isDisabled" :key="index" class="vcl-bulk-action__item">
            <a @click="activate(item)">
              {{ item.label }}
            </a>
          </li>
        </template>
      </ul>
      <i class="vcl-bulk-action__icon"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VpTableBulkAction',
  emits: ['visible'],
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
    actions: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    styles: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    _actions() {
      return this.actions.map((action) => {
        const { isDisabled = false } = action;
        if (typeof isDisabled === 'function') {
          return { ...action, isDisabled: isDisabled(this.selected) };
        }

        return action;
      });
    },
    bulkStyles() {
      const { zIndex, top, position, height } = this.styles || {};
      return {
        '--bulk-action-top': top || 'unset',
        '--bulk-action-index': zIndex || 'unset',
        '--bulk-action-height': height || 'fit-content',
        '--bulk-action-position': position || 'unset',
      }
    },
    visible() {
      return Boolean(this.selected && this.selected.length);
    }
  },
  watch: {
    visible(bool) {
      return this.$nextTick(() => this.$emit('visible', bool))
    }
  },
  methods: {
    activate(option) {
      return option.onClick(option.value, this.selected);
    },
  },
};
</script>

<style lang="scss" scoped>
  * {
    box-sizing: border-box;
  }
  .vcl-bulk-action {
    $self: &;
    top: var(--bulk-action-top);
    position: var(--bulk-action-position);
    z-index: var(--bulk-action-index);
    &__menu {
      z-index: 2;
      min-height: 55px;
      padding: .5rem 1.25rem;
      gap: 1rem;
      height: var(--bulk-action-height);
      margin-top: 1px;
      background-color: #016699;
      border: solid 1px #016699;
      display: flex;
      justify-content: space-between;
      align-items: center;
      #{ $self }__count {
        color: #fff;
        font-weight: bold;
        font-size: 14px;
        padding: 0;
        white-space: nowrap;
      }
      #{ $self }__items {
        row-gap: 0.25rem;
        column-gap: 1rem;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: flex-end;
        margin: 0;
        #{ $self }__item {
          list-style: none;
          a {
            text-decoration: underline;
            color: white;
            cursor: pointer;
          }
        }
      }
    }
    &__icon {
      position:absolute;
      bottom: -0.75rem;
      left: 16px;
      width:24px;
      height:12px;
      overflow:hidden;
      &::after {
        content:'';
        position:absolute;
        width:12px;
        height:12px;
        left: 50%;
        transform:translate(-50%,-45%) rotate(45deg);
        background-color:#016699;
        z-index: 4;
      }
    }
  }
</style>
